import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ButtonPrimary, colors, When, LoadingDot } from '@aftersale-next/ui';
import * as trackingActions from '../../config/constants/tracking-actions';
export default function ActionPicked(_ref) {
  var mutate = _ref.mutate,
      id = _ref.id,
      isLoading = _ref.isLoading;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(ButtonPrimary, {
    id: trackingActions.PICKED,
    disabled: isLoading,
    bgColor: colors.green,
    onClick: function onClick() {
      return mutate({
        action: trackingActions.PICKED,
        id: id
      });
    },
    children: [/*#__PURE__*/_jsx(When, {
      value: !isLoading,
      children: t('ACTION_PICKED')
    }), /*#__PURE__*/_jsx(When, {
      value: isLoading,
      children: /*#__PURE__*/_jsx(LoadingDot, {})
    })]
  });
}